<template lang="pug">
  v-dialog(v-model="show", v-if="estabelecimento", width="560px", persistent)
    v-card.dialogAgendar

      //- Header
      .dialogAgendar__header
        .dialogAgendar__header-iconWrap
          v-icon.dialogAgendar__header-icon(color="white") event_busy
        .dialogAgendar__header-text
          h2.dialogAgendar__titulo Pausar loja temporariamente
          p.dialogAgendar__subtitulo {{ estabelecimento.nome }}

      v-card-text.pt-4.pb-0.px-4

        //- Inputs de data — mesmo estilo dos inputs de horário
        v-layout(row).inputsGap
          v-flex.xs12.sm6
            v-text-field.bgcw.inputDefault(
              v-model="dataInicio",
              label="Inicio",
              type="datetime-local",
              outline,
              color="primary",
              :hide-details="!erros.dataInicio",
              :error-messages="erros.dataInicio",
              :disabled="loading"
            )
          v-flex.xs12.sm6
            v-text-field.bgcw.inputDefault(
              v-model="dataFim",
              label="Fim",
              type="datetime-local",
              outline,
              color="primary",
              :hide-details="!erros.dataFim",
              :error-messages="erros.dataFim",
              :disabled="loading"
            )

        //- Indicador de duração
        transition(name="duracaoFade")
          .duracaoBar(v-if="diffMinutos > 0 && diffDias === 0")
            .duracaoBar__line
            .duracaoBar__badge
              v-icon(color="white", small) schedule
              span.ml-1 {{ diffHoraTexto }}
            .duracaoBar__line
          .duracaoBar(v-else-if="diffDias > 0 && diffDias <= 30")
            .duracaoBar__line
            .duracaoBar__badge
              v-icon(color="white", small) schedule
              span.ml-1 {{ diffDias }} dia{{ diffDias > 1 ? 's' : '' }}
            .duracaoBar__line
          .duracaoBar.duracaoBar--aviso(v-else-if="dataInicio && dataFim && diffDias > 30")
            v-icon(color="#E53935", small) warning
            span.ml-1 A data não pode ser superior a 30 dias
          .duracaoBar.duracaoBar--aviso(v-else-if="dataInicio && dataFim && diffMinutos <= 0")
            v-icon(color="#E53935", small) warning
            span.ml-1 A data de fim deve ser após a data de início

        //- Motivo — estilo do filtro do catálogo
        v-text-field.mt-3(
          v-model="descricao",
          label="Motivo (opcional)",
          placeholder="Ex: Feriado, Viagem, Reforma...",
          color="gray",
          clearable,
          maxlength="200",
          counter="200",
          :hide-details="false",
          :disabled="loading"
        )

      v-card-actions.px-4.pb-4.pt-2
        v-layout(row, wrap, style="width:100%")
          v-flex.xs12.sm6.pa-1
            v-btn.btnCancelar(color="#FEFEFE", depressed, round, block, @click="fechar", :disabled="loading") Cancelar
          v-flex.xs12.sm6.pa-1
            v-btn.btnConfirmar(
              depressed, round, block,
              color="primary",
              :loading="loading",
              :disabled="!podeConfirmar",
              @click="confirmar"
            )
              v-icon.mr-1(small) check_circle
              | Confirmar
</template>

<script>
export default {
  data() {
    return {
      show: false,
      loading: false,
      estabelecimento: null,
      dataInicio: '',
      dataFim: '',
      descricao: '',
      erros: { dataInicio: null, dataFim: null },
    };
  },
  computed: {
    diffMinutos() {
      if (!this.dataInicio || !this.dataFim) return 0;
      return this.$dayjs(this.dataFim).diff(this.$dayjs(this.dataInicio), 'minute');
    },
    diffDias() {
      if (!this.dataInicio || !this.dataFim) return 0;
      return this.$dayjs(this.dataFim).diff(this.$dayjs(this.dataInicio), 'day');
    },
    diffHoraTexto() {
      const mins = this.diffMinutos;
      if (mins >= 60) {
        const h = Math.floor(mins / 60);
        const m = mins % 60;
        return m > 0 ? `${h}h ${m}min` : `${h}h`;
      }
      return `${mins}min`;
    },
    podeConfirmar() {
      return this.dataInicio && this.dataFim && this.diffMinutos > 0 && this.diffDias <= 30;
    },
  },
  methods: {
    open(estabelecimento) {
      this.estabelecimento = estabelecimento;
      this.dataInicio = '';
      this.dataFim = '';
      this.descricao = '';
      this.erros = { dataInicio: null, dataFim: null };
      this.loading = false;
      this.show = true;
    },
    fechar() {
      this.show = false;
    },
    validar() {
      this.erros = { dataInicio: null, dataFim: null };
      if (!this.dataInicio) { this.erros.dataInicio = 'Informe a data de início.'; return false; }
      if (!this.dataFim) { this.erros.dataFim = 'Informe a data de fim.'; return false; }
      if (this.diffMinutos <= 0) { this.erros.dataFim = 'A data de fim deve ser após a data de início.'; return false; }
      if (this.diffDias > 30) { this.erros.dataFim = 'O período máximo é de 30 dias.'; return false; }
      return true;
    },
    async confirmar() {
      if (!this.validar()) return;
      try {
        this.loading = true;
        await this.$axios.post('/recesso-estabelecimento', {
          estabelecimento_id: this.estabelecimento.id,
          estabelecimento_nome: this.estabelecimento.nome,
          data_inicio: this.$dayjs(this.dataInicio).format('YYYY-MM-DD HH:mm:ss'),
          data_fim: this.$dayjs(this.dataFim).format('YYYY-MM-DD HH:mm:ss'),
          descricao: this.descricao ? `${this.descricao} | Fechamento Agendado` : 'Fechamento Agendado',
          ativo: 1,
        });
        window.getApp.$emit('APP_ALERT', {
          color: 'success',
          text: `Fechamento agendado! A loja ficará fechada de ${this.$dayjs(this.dataInicio).format('DD/MM HH:mm')} até ${this.$dayjs(this.dataFim).format('DD/MM HH:mm')}.`,
        });
        this.$emit('agendado');
        this.fechar();
      } catch (error) {
        const msg = error.response && error.response.data ? error.response.data.error : 'Erro ao agendar fechamento. Tente novamente.';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: msg });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
  .inputDefault .v-input__control .v-input__slot{
    background-color: #f6f6f6!important;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, .15)!important;
  }

  .inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot{
    border: 1px solid #1d9a5a !important;
  }
</style>

<style lang="scss" scoped>
$primary: #1D9A5A;
$primary-dark: #157345;

.bgcw { background-color: #fff; }

.inputsGap {
  gap: 12px;

  .flex {
    min-width: 0;
  }
}

.dialogAgendar {
  border-radius: 12px !important;
  overflow: hidden;
  font-family: "Poppins", "Roboto", sans-serif;

  &__header {
    background-color: #1D9A5A;
    padding: 22px 24px 20px;
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__header-iconWrap {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.18);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__header-icon {
    font-size: 26px !important;
  }

  &__titulo {
    font-size: 17px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 2px;
    line-height: 1.3;
  }

  &__subtitulo {
    font-size: 13px;
    color: rgba(255,255,255,0.75);
    margin: 0;
    font-weight: 400;
  }
}

.duracaoBar {
  display: flex;
  align-items: center;
  margin: 14px 0 4px;
  gap: 10px;

  &__line {
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, transparent, #CBD5E0, transparent);
  }

  &__badge {
    background: $primary;
    color: #fff;
    border-radius: 20px;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(29, 154, 90, 0.3);
  }

  &--aviso {
    justify-content: center;
    font-size: 13px;
    color: #E53935;
    font-weight: 500;
    margin: 10px 0 0;
    gap: 4px;
  }
}

.btnCancelar {
  font-weight: 500;
  color: #6B7A8D !important;
  text-transform: none;
  letter-spacing: 0;
}

.btnConfirmar {
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  padding: 0 20px !important;
  height: 38px !important;
}

.duracaoFade-enter-active,
.duracaoFade-leave-active {
  transition: opacity 0.25s, transform 0.25s;
}
.duracaoFade-enter,
.duracaoFade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

@media (max-width: 599px) {
  .inputsGap {
    flex-direction: column;

    .flex {
      width: 100%;
    }
  }
}
</style>
